import {
    Avatar,
    Box,
    Button,
    Checkbox,
    Chip,
    Divider,
    FormControlLabel,
    IconButton,
    List,
    ListItem,
    ListItemAvatar,
    ListItemButton,
    ListItemText,
    Popover,
    TextField,
    Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import Modal2 from "../../components/Modal/Modal2";
import { CheckCircleOutlineOutlined, Close, KeyboardArrowDown } from "@mui/icons-material";
import { Nodata } from "../../icons/Nodata";
import { Plus } from "../../icons/plus";
import PlusIcon from "../../icons/PlusIcon";
import { EditIcon } from "../../icons/edit-icon";
import { config, styles } from "../../style";
import { useDispatch } from "react-redux";
import { createSpeakerList2Async, updateSpeakerListAsync } from "./speakerSearchSlice";
import { AlertDialog } from "../../components/AlertDialog";
import { ListsIcon } from "../../icons/ListsIcon";

function MyList({
    data,
    currentListRecord = {},
    setCurrentListRecord,
    setListName = () => {},
    handlePrivateChange = undefined,
    currentCreateRecord,
    handleEditList,
    setSelectedSpeakerList,
    selectedSpeakerList,
    handleRemoveFilter2,
    setCurrentCreateRecord,
    userDetails,
    onFilterSelect,
    handleCreate,
}) {
    const [isCreateListModalOpen, setIsCreateListModalOpen] = useState(false);
    const [isEditListModalOpen, setIsEditListModalOpen] = useState(false);

    const [openListDeleteConfirmationModal, setOpenListDeleteConfirmationModal] = useState(false);

    // console.log("items",items);

    const [anchorEl, setAnchorEl] = React.useState(null);

    const dispatch = useDispatch();

    const open = Boolean(anchorEl);

    const id = open ? "simple-popover" : undefined;

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = (value) => {
        setAnchorEl(null);
    };

    const handleListDeleteConfirmationOpen = () => {
        setOpenListDeleteConfirmationModal(true);
    };
    const handleListDeleteConfirmationClose = () => {
        setOpenListDeleteConfirmationModal(false);
    };

    const handleListDeleteConfirmationAgree = () => {
        dispatch(
            updateSpeakerListAsync({
                list: {
                    ...currentListRecord,
                    contactId: userDetails?.contact?.id,
                    isDeleted: true,
                },
                speakerId: currentCreateRecord?.Id,
            })
        );
        setSelectedSpeakerList(undefined);
        setCurrentListRecord(undefined);
        setCurrentCreateRecord(undefined);
        setOpenListDeleteConfirmationModal(false);
        handleEditListModalHide();
    };

    const handleCreateListModalOpen = () => {
        handleCreate();
    };
    const handleCreateListModalHide = () => {
        setCurrentListRecord(undefined);
        setCurrentCreateRecord(undefined);

        setIsCreateListModalOpen(false);
    };

    const handleCreateListModalSave = () => {
        if (currentListRecord.name) {
            dispatch(
                createSpeakerList2Async({
                    list: {
                        ...currentListRecord,
                        contactId: userDetails?.contact?.id,
                        accountId: userDetails?.contact?.accountId,
                    },
                    // speakerId: currentCreateRecord?.Id,// this data not getting
                })
            );
            setSelectedSpeakerList(undefined);
            setCurrentListRecord(undefined);
            setCurrentCreateRecord(undefined);
            setIsCreateListModalOpen(false);
        }
    };

    const handleEditListModalOpen = () => {
        handleEditList({
            callback: () => setIsEditListModalOpen(true),
        });
    };
    const handleEditListModalHide = () => {
        setCurrentListRecord(undefined);
        setCurrentCreateRecord(undefined);
        setIsEditListModalOpen(false);
    };

    const handleEditModalSave = () => {
        // handleUpdateListSave2({
        //     callback:setIsEditListModalOpen(false)
        // })

        if (currentListRecord.name) {
            dispatch(
                updateSpeakerListAsync({
                    list: {
                        ...currentListRecord,
                        contactId: userDetails?.contact?.id,
                    },
                    speakerId: currentCreateRecord?.Id,
                })
            );
            setSelectedSpeakerList(currentListRecord);
            // setOpenCreateListModal(false);
            setCurrentListRecord(undefined);
            setCurrentCreateRecord(undefined);
            setIsEditListModalOpen(false);
        }
    };

    const getImageURL = () => {
        return selectedSpeakerList?.speakerPortalImage
            ? selectedSpeakerList?.speakerPortalImage
            : selectedSpeakerList?.speakerImagePublicURL;
    };

    const handleRemoveList = (record) => {
        // const createEvent = new CustomEvent("removeSpeaker", {
        //     detail: {
        //         value: record, //speaker id
        //         listId: listId, //my list item
        //     },
        // });
        // document.dispatchEvent(createEvent);

        handleRemoveFilter2(record);
    };

    // console.log("selectedSpeakerList", data, selectedSpeakerList);

    useEffect(() => {
        //added this code to set new data when remove button click in edit list
        setSelectedSpeakerList(data?.speakerLists?.find((item) => item.id === selectedSpeakerList?.id));
    }, [data]);

    const NoDataUI = (
        <>
            {/* No Data UI */}
            <Box
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                height={"175px"}
                width={"325px"}
                flexDirection={"column"}
                gap={"6px"}>
                <Nodata />

                <Typography
                    sx={{
                        color: "rgba(6, 6, 24, 0.30)",
                        fontSize: "14px",
                        fontStyle: "normal",
                        fontWeight: 500,
                        lineHeight: "normal",
                    }}>
                    {" "}
                    You haven't create any lists.{" "}
                </Typography>
            </Box>
        </>
    );
    // console.log("data.speakerLists.................", data.speakerLists);

    return (
        <>
            <Box>
                <DropdownBtn
                    text={selectedSpeakerList ? "Remove List Filter" : "My List"}
                    // handleClick={handleClick}
                    handleDropDown={handleClick}
                    onClose={() => setSelectedSpeakerList("")}
                    showCloseButton={selectedSpeakerList ? true : false}
                />
            </Box>

            {/* Menu List  */}
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}

                //   disableScrollLock={true}
            >
                <Box padding={"12px 8px"} sx={{ minWidth: { sm: "20rem" } }}>
                    <Box padding={"6px 10px"} display={"flex"} alignItems={"center"} justifyContent={"flex-start"}>
                        <Plus />
                        <Typography
                            sx={{
                                color: "#101828",
                                fontSize: "14px",
                                fontStyle: "normal",
                                fontWeight: 500,
                                lineHeight: "142.857%",
                                marginLeft: "8px",
                            }}>
                            My Created Lists
                        </Typography>
                    </Box>

                    <Divider
                        sx={{
                            borderColor: "#101828",
                            opacity: "0.1",
                        }}
                    />

                    <Box>
                        {data?.speakerLists?.length > 0 ? (
                            <>
                                <List
                                    sx={{
                                        paddingTop: "1rem",
                                        paddingBottom: "1rem",
                                    }}>
                                    {/* {data?.speakerLists.map((item) => {
                                        return {
                                            label: `${item.name} (${item.members.length})`,
                                            id: item.id,
                                        };
                                    })} */}

                                    {data.speakerLists.map((item) => (
                                        <ListItem
                                            key={item.id}
                                            disablePadding
                                            sx={{
                                                "&:hover": {
                                                    borderRadius: "6px",
                                                    backgroundColor: "#F7F6FE",
                                                },

                                                ...(selectedSpeakerList?.id === item?.id && {
                                                    borderRadius: "6px",
                                                    backgroundColor: "#F7F6FE",
                                                }),
                                            }}
                                            secondaryAction={
                                                <Box
                                                    display={"flex"}
                                                    justifyContent={"center"}
                                                    alignItems={"center "}
                                                    color={"inherit"}>
                                                    {item.type === "Private" && (
                                                        <Chip
                                                            avatar={<CheckCircleOutlineOutlined />}
                                                            label="private"
                                                            sx={{
                                                                background: "rgba(0,0,0,0.08)",
                                                                padding: "2px 6px",
                                                                fontSize: "10px",
                                                                fontWeight: 500,
                                                                color: "#101828",
                                                                height: "unset",

                                                                marginRight: "0.5rem",

                                                                "& .MuiChip-avatar": {
                                                                    width: "10px",
                                                                    height: "10px",
                                                                    padding: 0,
                                                                    margin: 0,
                                                                    marginRight: "2px",
                                                                },

                                                                "& .MuiChip-label": {
                                                                    padding: 0,
                                                                    margin: 0,
                                                                },
                                                            }}></Chip>
                                                    )}
                                                    <Typography
                                                        fontSize={"0.75rem"}
                                                        fontWeight={500}
                                                        color={"#22315A"}
                                                        lineHeight={"133.333%"}
                                                        marginRight={"0.5rem"}>
                                                        {item.members.length}
                                                    </Typography>

                                                    <IconButton
                                                        disabled={userDetails.contact?.id !== item.contactId}
                                                        onClick={() => {
                                                            handleEditList(item);
                                                        }}
                                                        sx={{
                                                            padding: 0,
                                                            margin: 0,
                                                            opacity:
                                                                userDetails.contact?.id !== item.contactId ? 0.3 : 1,
                                                        }}>
                                                        <EditIcon />
                                                    </IconButton>
                                                </Box>
                                            }>
                                            <ListItemButton
                                                sx={{
                                                    "&.MuiButtonBase-root.MuiListItemButton-root.MuiListItemButton-root":
                                                        {
                                                            paddingRight: "8rem",
                                                        },
                                                }}
                                                onClick={(event) => {
                                                    onFilterSelect(event, { ...item });
                                                    setAnchorEl(null);
                                                }}
                                                title={item.name}>
                                                <Typography
                                                    sx={{
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        maxWidth: "150px",
                                                    }}
                                                    title={item.name}
                                                    fontSize={"0.875rem"}
                                                    fontWeight={500}
                                                    color={"#101828"}>
                                                    {item.name}
                                                </Typography>
                                            </ListItemButton>
                                        </ListItem>
                                    ))}
                                </List>
                            </>
                        ) : (
                            NoDataUI
                        )}
                    </Box>

                    <Button
                        fullWidth
                        startIcon={<PlusIcon />}
                        variant="outlined"
                        color="primary"
                        onClick={handleCreateListModalOpen}>
                        Create List
                    </Button>
                </Box>
            </Popover>

            {/* Create List Open Modal  NOT USING*/}
            <Modal2
                open={false}
                SubmitButtonText="Create List"
                hideHeading={true}
                contentSx={{
                    padding: "1rem 0",
                }}
                onModalSubmit={handleCreateListModalSave}
                onClose={() => {
                    // current modal
                    handleCreateListModalHide();
                }}>
                <Typography
                    sx={{
                        color: "#101828",
                        fontSize: "18px",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "144.444%", // Equivalent to 26px
                        marginBottom: "0.5rem",
                    }}>
                    Create new list
                </Typography>
                <TextField
                    fullWidth
                    label="List name"
                    variant="outlined"
                    value={currentListRecord?.name}
                    onChange={(event) => setListName(event.target.value)}
                />
                <Box>
                    <FormControlLabel
                        control={
                            <Checkbox
                                sx={{
                                    //  check box border color
                                    color: "#444CE7",
                                }}
                                checked={currentListRecord?.type === "Private"}
                                onChange={handlePrivateChange}
                                inputProps={{ "aria-label": "controlled" }}
                            />
                        }
                        label={"Make list private"}
                    />
                </Box>
            </Modal2>

            {/* Edit List Open Modal   NOT USING */}
            <Modal2
                open={false}
                SubmitButtonText="Save Changes"
                hideHeading={true}
                contentSx={{
                    padding: "1rem 0",
                }}
                onClose={handleEditListModalHide}
                showDeleteButton={true}
                onDelete={handleListDeleteConfirmationOpen}
                onModalSubmit={handleEditModalSave}>
                <Typography
                    sx={{
                        color: "#101828",
                        fontSize: "18px",
                        fontStyle: "normal",
                        fontWeight: 600,
                        lineHeight: "144.444%", // Equivalent to 26px
                        marginBottom: "0.5rem",
                    }}>
                    Edit My lists
                </Typography>
                <TextField
                    fullWidth
                    label="List name"
                    variant="outlined"
                    value={currentListRecord?.name}
                    onChange={(event) => setListName(event.target.value)}
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            sx={{
                                //  check box border color
                                color: "#444CE7",
                            }}
                            checked={currentListRecord?.type === "Private"}
                            onChange={handlePrivateChange}
                            inputProps={{ "aria-label": "controlled" }}
                        />
                    }
                    label={"Make list private"}
                />

                {selectedSpeakerList?.members?.length > 0 && (
                    <Box marginTop={"1.5rem"}>
                        <Typography fontSize={"1rem"} fontWeight={600} color={"#101828"} lineHeight={"150%"}>
                            Saved Speakers
                        </Typography>

                        <List
                            sx={{
                                width: "100%",
                                bgcolor: "background.paper",
                                borderTop: "1px solid rgba(0,0,0,0.06)",
                                borderBottom: "1px solid rgba(0,0,0,0.06)",
                                marginTop: "0.875rem",
                            }}>
                            {selectedSpeakerList?.members?.map((item) => {
                                const labelId = `checkbox-list-secondary-label-${item}`;
                                return (
                                    <ListItem
                                        key={item}
                                        secondaryAction={
                                            <Button
                                                variant="outlined"
                                                sx={styles.outlinedButton}
                                                onClick={() => handleRemoveList(item)} //record,listId
                                            >
                                                Remove
                                            </Button>
                                        }
                                        disablePadding>
                                        <ListItemButton>
                                            <ListItemAvatar>
                                                <Avatar alt={`Avatar n°${item + 1}`} src={getImageURL()} />
                                            </ListItemAvatar>
                                            <ListItemText
                                                id={labelId}
                                                primary={`${item.speakerName}`}
                                                secondary={item.name}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                );
                            })}
                        </List>
                    </Box>
                )}
            </Modal2>

            {/* Confirmation Modal */}
            {openListDeleteConfirmationModal && (
                <AlertDialog
                    title="Confirm"
                    message="Are you sure, you want to remove this record for the list?"
                    open={openListDeleteConfirmationModal}
                    onDisagree={handleListDeleteConfirmationClose}
                    onAgree={handleListDeleteConfirmationAgree}></AlertDialog>
            )}
        </>
    );
}

const DropdownBtn = ({
    handleClick = undefined,
    text = "",
    sx = {},
    onClose,
    showCloseButton,
    handleDropDown,
    ...props
}) => {
    const ref = useRef();

    return (
        <Button
            onClick={() => {
                handleDropDown({ currentTarget: ref.current });
            }}
            ref={ref}
            sx={{
                padding: { xs: "0.5rem 0.625rem", sm: "0.875rem 1rem" },

                fontSize: "1rem",
                fontWeight: "500",
                lineHeight: "1.5rem",
                background: "#FFFFFF",

                borderRadius: "10px",
                boxShadow:
                    "0px 0px 0px 1px rgba(107, 144, 192, 0.0486779), 0px 1px 2px rgba(89, 97, 104, 0.147645), 0px 2px 8px rgba(89, 97, 104, 0.0960719)",

                ...sx,
            }}
            startIcon={<ListsIcon sx={{ color: config.primaryColor }} />}
            endIcon={
                <KeyboardArrowDown
                    onClick={() => {
                        // const createEvent = new CustomEvent("removeSpeaker", {
                        //     currentTarget: ref.current,
                        // });
                        // document.dispatchEvent(createEvent);

                        // handleDropDown(createEvent);

                        handleDropDown({ currentTarget: ref.current });
                    }}
                />
            }
            {...props}>
            <Box display={"flex"} justifyContent={"space-around"} alignItems={"center"}>
                {text}{" "}
                {showCloseButton && (
                    <IconButton
                        onClick={onClose}
                        sx={{
                            padding: 0,
                            margin: 0,
                            marginLeft: "0.5rem",

                            "& .MuiSvgIcon-root": {
                                fontSize: "1rem",
                            },
                        }}>
                        <Close />
                    </IconButton>
                )}
            </Box>
        </Button>
    );
};

export default MyList;
